import React, { useState } from 'react';
import Input from './Input';
import debounce from 'lodash.debounce';
import content from './../Translations/Registration';

function NicknameInputWithValidation(props) {
    const [errorText, setErrorText] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    function onChange(value) {
        const res = props.validation(value);
        props.onChange({ val: value, valid: false });
        if (typeof res.then === 'function') {
            setErrorText(content[props.lang] ? content[props.lang].userLoading : content['en-EN'].userLoading);
            props.onChange({ val: value, valid: false });
            res
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.LoginExist === "0") {
                            setErrorText("");
                            setSuggestions([]);
                            props.onChange({ val: value, valid: true });
                        } else {
                            setErrorText(content[props.lang] ? content[props.lang].userVal4 : content['en-EN'].userVal4);
                            props.onChange({ val: value, valid: false });
                            let suggestions = result.Suggestions.split(',');
                            setSuggestions(suggestions);
                        }
                    },
                    (error) => {
                        console.log(error);
                        setErrorText("Request failed");
                        props.onChange({ val: value, valid: false });
                    }
                );
        } else {
            setErrorText(res);
            setSuggestions([]);
            props.onChange({ val: value, valid: false });
        }
    }

    function suggestionClick(index) {
        onChange(suggestions[index]);
        document.getElementById("username").value = suggestions[index];
        setSuggestions([]);
        props?.onClickSuggestion();
    }

    return (
        <div className={"input-with-validation nickname " + ((suggestions.length > 0 && suggestions[0] != "") ? "suggestions-shown" : "")}>
            <Input
                placeholder={props.placeholder}
                onChange={debounce(onChange, 1000, { 'maxWait': 1500 })}
                id="username"
                onFocus={props.onFocus}
            />
            {
                !props.value.valid &&
                <div className="error-text">
                    {errorText}
                </div>
            }
            {
                suggestions.length > 0 && suggestions[0] != "" &&
                <div className="suggestions">
                    <div onClick={suggestionClick.bind(this, 0)}>
                        {suggestions[0]}
                    </div>
                    <div onClick={suggestionClick.bind(this, 1)}>
                        {suggestions[1]}
                    </div>
                </div>
            }
        </div>
    );
}

export default NicknameInputWithValidation;